<template>
  <v-app v-bind:class="{ 'ic-content':$route.name!='cover' }" :role="'cid-'+cid">
    <router-view/>

    <!--<v-snackbar bottom right :value="updateExists" :timeout="-1" color="warning">
      An update is available
      <v-btn class="primary" text @click="refreshApp">
        Update
      </v-btn>
    </v-snackbar>-->
    <div style="font-size: 10px;
    text-align: center;
    font-style: italic;
    display: none;">v1.0</div>
  </v-app>
</template>

<script>
import update from './mixins/update'

export default {
  name: "App",
  data() {
    return {
      meta: {
        title: "Interactive Content",
        description: " ic ",
        image: ""
      },
      isEmbed: this.$store.state.isEmbed || false,
      cid: null
    };
  },
  mixins: [update],
  
  mounted() {

    var th = this

    /** check is embed */
    const queryString = window.location.search
    if( queryString )
    {
        const urlParams = new URLSearchParams(queryString)

        if(urlParams.get('embed')) 
        {
          this.isEmbed = true
          this.$store.state.isEmbed = true
        }
    }
    /** check is embed */

    window.addEventListener('message', function(event) {

        var params = {event:null};

        if(event && th.checkIsJSON(event.data)) {
            try {
                params = JSON.parse(event.data);
            } catch (e) {
                console.log(e)
            }
        }
        
        if(params.event=='parentLocation')
        {
            th.$store.state.iframe_url = params.value
        }
        
        if(event.data.eventName=='pushUserId')
        {
            th.$store.state.data.visitorId = event.data.value
        }

    }, false);
    
    window.addEventListener('ic:finished', function() {        
        var _referrer = th.$route.query.ref ? decodeURIComponent(th.$route.query.ref) : null
            _referrer = _referrer||(document.referrer ? document.referrer : window.location.href);
        parent.postMessage(JSON.stringify({
          'event': 'newshub_ic2_result',
          'ic_id': th.$store.state.data.get.id,
          'user_id': th.$store.state.data.userLogin ? th.$store.state.data.userLogin.data.id : null,
          'visitor_id': th.$store.state.data.visitorId
        }), _referrer);
    });

  },
  beforeCreate()
  {

  },
  head: {
    title: function() {
      return {
        inner: this.$store.state.data.meta.title
      };
    },
    meta: function() {
      return [
        {
          name: "description", content: this.$store.state.data.meta.title, id: "desc"
        },
        {
          name: "twitter:description", content: this.$store.state.data.meta.description, id: "twitter_description"
        },
        {
          name: "twitter:title", content: this.$store.state.data.meta.title, id: "twitter_title"
        },
        {
          name: "og:title", content: this.$store.state.data.meta.title, id: "og_title"
        },
        {
          name: "og:image", content: this.$store.state.data.meta.image, id: "og_image"
        },
        {
          name: "twitter:image", content: this.$store.state.data.meta.image, id: "tw_image"
        },
        {
          name: "twitter:card", content: "summary_large_image", id: "tw_card"
        }
      ];
    }
  },
  methods: {
    updateHead()
    {
      this.$emit("updateHead");
      
      //re render instagram embed
      setTimeout(function(){
          if( typeof window.instgrm !== 'undefined')
          {
            window.instgrm.Embeds.process()
          }
          if( typeof window.twttr !== 'undefined')
          {
            window.twttr.widgets.load()
          }
      }, 800);
      
    },
    checkIsJSON(str) 
    {
        try {
          var json = JSON.parse(str);
          return (typeof json === 'object');
        } catch (e) {
          return false;
        }
    },
    resizeWindow(id, elmn)
    {
      //resize window
      var _referrer = this.$route.query.ref ? decodeURIComponent(this.$route.query.ref) : null
          _referrer = _referrer||(document.referrer ? document.referrer : window.location.href);

      this.$store.state.data.post.referrer = _referrer;

      //clear interval
      if( this.$store.state.interval )
      {
        clearInterval(this.$store.state.interval);
      }
      
      var urlPrms = new URLSearchParams(window.location.search)
      
      this.cid = urlPrms.get('cid') || '';

      this.$store.state.interval = setInterval(function(){
            parent.postMessage(JSON.stringify({
              'event': 'newshub_ic2_resize',
              'height': document.getElementById(elmn)?.offsetHeight || document.body.offsetHeight,
              'id': id,
              'cid' : urlPrms.get('cid')
            }), _referrer);
            //console.log('resize:' +document.getElementById(elmn).offsetHeight || document.body.offsetHeight)
      }, 1000);
      
      parent.postMessage(JSON.stringify({
        'event': 'newshub_ic2_onload',
        'id': id,
        'cid' : urlPrms.get('cid')
      }), _referrer);
    }
  }
};
</script>
